import { render, staticRenderFns } from "./old.vue?vue&type=template&id=1545b35c&scoped=true"
import script from "./old.vue?vue&type=script&lang=js"
export * from "./old.vue?vue&type=script&lang=js"
import style0 from "./old.vue?vue&type=style&index=0&id=1545b35c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1545b35c",
  null
  
)

export default component.exports